<template>
	<div>
		<div  class="zjzt"><!-- zjzt -->
			
			<ul class="title1">
				<li class="L"><a href=""  >中经专题</a></li>
				<li class="M"></li>
			</ul>
			
			
			<div  class="zjzt_scroll_wrap"><!-- zjzt_scroll_wrap -->
				
				<div  class="group1 " ><!-- group1 -->
					<div  class="group1_L " ><!-- group1_L -->
						<div  class="ZT_banner " v-loading="isloadingimg" ><!-- ZT_banner -->
							<a href="javascript:;" @click="$router.push({ name: bannersrc })" name="D_Subscribe"><img :src="bannerdata"  alt="" style="width: 638px; height: 296px;"/></a>
						</div><!-- /ZT_banner -->
					</div><!-- /group1_L -->
					<div  class="group1_R  "><!-- group1_R -->
						<figure class="MyTabs Tabs2"><!-- MyTabs -->
						  <ul class="MyTabs-tabs">
							<li class="MyTabs-tab active"><a href="javascript:;"  >推荐阅读</a></li>
						  </ul>
						  <div class="MyTabs-content"><!-- MyTabs-content -->
							<div class="MyTabs-pane" v-loading="isloadingtuijian">
								<ul  class="list1"  >
									<li v-for="item in tuijianList"><a @click="jumppush('/detail/'+item.id+'?col='+zhuantiurlList[highlightId])" target="_blank">{{item.title}}</a></li>
								</ul>
							</div>
						  </div><!-- /MyTabs-content -->
						</figure><!-- /MyTabs -->								
					</div><!-- /group1_R -->
				</div><!-- /group1 -->	
				
				<div class="m_b1"></div>
				
				<div  class="zjzt_scroll"><!-- zjzt_scroll -->
					<div  id="zt_left" class="zt_arrow" :style="{'pointer-events':showpage==0?'none':''}"  @click="pre()"></div>
					<div  class="zjzt_scroll_list">
						<ul :style="{'left':'-'+showpage*175+'px'}">
							<li v-for="(item,index) in zhuantiList.data" :class="highlightId==item.columnid?'on':''"
							 @mouseenter="zhuantiChange(item.columnid,item.columnname)"
							 >
								<div @click="$router.push({ name: zhuantiurlList[item.columnid]?zhuantiurlList[item.columnid]:'' })" class="img_min"><i class="hot"></i><mark></mark><img :src="zhuantiList.images[item.columnid]" alt=""/></div>
								<div  class="colorline"></div>
								<h1 style="cursor: pointer;" @click="$router.push({ name: zhuantiurlList[item.columnid]?zhuantiurlList[item.columnid]:'' })">{{item.columnname}}</h1>
								<div><a @click="$router.push({ name: zhuantiurlList[item.columnid]?zhuantiurlList[item.columnid]:'' })" class="more1" ></a></div>
							</li>
						</ul>
						<div  class="baseline"></div>
						
					</div>
					<div  id="zt_right" class="zt_arrow" :style="{'pointer-events':showpage>=maxpage?'none':''}" @click="next()"></div>
				</div><!-- /zjzt_scroll -->
				
				
				
				
			</div><!-- /zjzt_scroll_wrap -->
			
		</div><!-- /zjzt -->
		
		
		
		
	</div>
	
</template>

<script>
	export default {
		data() {
			return {
				isloadingimg:true,
				isloadingtuijian:true,
				zhuantiList: [],
				showpage:0,
				maxpage:0,
				highlightId:'0a77b388a5cd4bb8a73d9d66fdce53ad',
				bannerdata:'',
				bannersrc:'',
				tuijianList:[],
				zhuantiurlList:{
					'd03917d67ce246fb943db80713787864':'ztlianghui',
					'0a77b388a5cd4bb8a73d9d66fdce53ad':'zthongguan',
					'ded94875241744fb8d7ff2ceca693ad7':'ztshuzijingji',
					'94f3f6ed4c3d4bc5a1a3fd305062ff27':'ztshuangtan',
					'0624d17680a64d7e8ea070035ecb09b8':'ztguojijingji',
					'07c8db10b4d445aebc7373dea216b4e1':'ztxiandaijinrong',
					'60e6ac0b4d604c019ffbfbb72411a30b':'ztchanyejingji',
					'a4f3a51d46aa4002865234c9ef889aa7':'ztquyufazhan',
					'81cf99dfeb7c40fda4f800353d898614':'ztgongzuohui',
					'56ce6ee282074164803964bf3bace0d2':'ztjujiao',
					'1697a508307647a39fea5b77e5c944fd':'ztchengshigengxin',
					'9edbe223d20b4bddbc430f2324be117c':'ztxiangcunzhenxing',
					'91b8b0050d604a3f9593d6bc7a36fa51':'ztxinxingchengzhenhua',
					'8c1fb2cbcccf4c9a8bf272f9ccffa651':'ztminyingjingji',
				},
				zhuantiImageList:{
					'd03917d67ce246fb943db80713787864':'21bdfbd18bf14fb280c0c6085e65fbb1',
					'0a77b388a5cd4bb8a73d9d66fdce53ad':'055828cbc7864456a8087c4238e2229d',
					'ded94875241744fb8d7ff2ceca693ad7':'9616dd1e137f49919dc2b4d5a83d802d',
					'94f3f6ed4c3d4bc5a1a3fd305062ff27':'bbd47c21f976474e9f642c7aa7eacdab',
					'0624d17680a64d7e8ea070035ecb09b8':'5091c335c73244df8fde329c7653e8b7',
					'07c8db10b4d445aebc7373dea216b4e1':'bb75ced3b99b45b091488000a23dcdfb',
					'60e6ac0b4d604c019ffbfbb72411a30b':'4ac3ddf6c66448b8a91c64454e311341',
					'a4f3a51d46aa4002865234c9ef889aa7':'a1e00d694f6f4a59bc2389edfbcec213',
					'81cf99dfeb7c40fda4f800353d898614':'2b8e714b8cb84ce7b8cb29c3819f7367',
					'56ce6ee282074164803964bf3bace0d2':'8c165862d523425b8805a303bc4b4737',
					'1697a508307647a39fea5b77e5c944fd':'1e9cbdea20c44d84b51e6f7482be96d6',
					'9edbe223d20b4bddbc430f2324be117c':'172239ce48104b408811fae97cb6c443',
					'91b8b0050d604a3f9593d6bc7a36fa51':'b2595462ae6e428f8d1faae9c6203b54',
					'8c1fb2cbcccf4c9a8bf272f9ccffa651':'ac6fdec210f74c318c52a6aba07661e6',
				}
			}
		},
		created: function() {
			this.zhuantifnc();
		},
		mounted() {
			this.tuijianfnc('宏观经济');
			this.bannerfnc('0a77b388a5cd4bb8a73d9d66fdce53ad')
		},
		computed: {
	
		},
		methods: {
			showLogin: function() {
				this.$emit('showLogin');
			},
			jumppush:function(to){
				if(!this.$cookies.get('userinfo')){
					this.showLogin();
					this.$cookies.set('fromdetail',to);
					return false;
				}
				else{
					var a = document.createElement('a');
					a.setAttribute('href', to);
					a.setAttribute('style', 'display:none');  
					a.setAttribute('target', '_blank');  
					document.body.appendChild(a);
					a.click();
					a.parentNode.removeChild(a); 
				}
			},
			zhuantiChange:function(id,name){
				if(this.highlightId!=id){
					this.highlightId=id;
					this.tuijianfnc(name);
					this.bannerfnc(id);
				}
			},
			tuijianfnc: function(ztname) {
				this.isloadingtuijian=true;
				let _this = this;
				this.$http({
						method: 'get',
						url: 'getXZWSubjectHotArticles',
						responseType: 'json',
						params: {
							cName:ztname
						},
					})
					.then(function(response) {
						_this.tuijianList=response.data.data.data;
						_this.isloadingtuijian=false;
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			bannerfnc: function(id) {
				this.isloadingimg=true;
				this.bannersrc=this.zhuantiurlList[id]?this.zhuantiurlList[id]:'';
				let _this = this;
				this.$http({
						method: 'get',
						url: 'selecImgtBycolumnID',
						responseType: 'json',
						params: {
							columnID: this.zhuantiImageList[id],
						},
					})
					.then(function(response) {
						_this.bannerdata=response.data.data.data.images[_this.zhuantiImageList[id]];
						_this.isloadingimg=false;
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			zhuantifnc: function() {
				let _this = this;
				// this.resultDataList = {};
				// this.totalResultCount = 0;
				this.$http({
						method: 'get',
						url: 'selectByparentID',
						responseType: 'json',
						params: {
							parentID: '65a8a56d1e3c4c649343a59d509016d8',
						},
					})
					.then(function(response) {
						// console.log(response);
						// debugger;
						var temparr=response.data.data.data;
						for(var i=temparr.data.length-1;i>-1;i--){
							if(!_this.zhuantiurlList[temparr.data[i].columnid]){
								temparr.data.splice(i,1);
							}
						}
						// for(var i=0;i<temparr.data.length;i++){
						// 	if(temparr.data[i].columnnamethird=='专精特新'){
						// 		temparr.data.splice(i,1);
						// 		break;
						// 	}
						// }
						_this.zhuantiList = temparr;
						_this.maxpage=(_this.zhuantiList.data.length-7)>0?(_this.zhuantiList.data.length-7):0;
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			pre:function(){
				if(this.showpage>0){
					this.showpage--;
				}
				else{
					this.showpage==0;
				}
			},
			next:function(){
				if(this.showpage<this.maxpage){
					this.showpage++;
				}
			},
		}
	}
</script>

<style>
</style>
